import React, { useEffect } from "react";
import "./style.css";
import useStatus from "../../../hooks/useStatus";
const EnvironmentStatusHeader = () => {
  const { status, devActive, stageActive } = useStatus();
  const statusClass = devActive
    ? "statusheader--dev"
    : stageActive
    ? "statusheader--staging"
    : "";

  return (
    <div className={`statusheader ${statusClass}`}>{status && status}</div>
  );
};

export default EnvironmentStatusHeader;
